// Settings page — destination for /settings.

import { Settings } from '@/v2/v3/Settings'

// v3 rebuild: /settings renders the v3 Settings screen (borderless,
// shared shell). The legacy AppLayout-based body (ADR-0039 toggles +
// Account/About sections) was trimmed in the B4 cleanup — see git history;
// the live v3 Settings screen carries its own versions of those controls.
export function V2SettingsPage() {
  return <Settings />
}
